import { Injectable }    from '@angular/core';
import {
	MissingTranslationHandler,
	MissingTranslationHandlerParams
}                        from '@ngx-translate/core';
import { LoggerService } from '@shared/services/logger.service';


@Injectable( { providedIn: 'root' } )
export class TranslationHelperService implements MissingTranslationHandler {

	constructor(
		private _logger: LoggerService
	) {}

	handle( params: MissingTranslationHandlerParams ): string {
		const keyPathSegments: string[] = params.key.split( '.' );
		const isNoValueNoTranslation: boolean = keyPathSegments.includes( 'null' ) || keyPathSegments.includes( 'undefined' );

		// Logs not value dependant missing translations paths only
		if ( !isNoValueNoTranslation ) {
			this._logger.log( `Missing translation for i18n path: ${ params.key }` );
			return params.key;
		}

		return '';
	}
}
